<template src="./Menu.html"></template>

<script>
import { mapGetters } from "vuex";
import { getRoleName } from "../../services";
import {
  AdminAndCompanyAdmin,
  NotAnalyst,
  NotAccounting,
  OnlyRisk,
  OnlyAdmin,
  OnlyAdminAndAccounting,
  ComplianceAndAdmin,
  NotCompliance,
  AdminCompliance,
  NotClientCompliance,
  OnlyClientCompliance,
  OnlyCompany,
  adminAndRiskAdmin,
  complianceRisk,
  CanApprove,
  OnlyCompanyAdmin,
  NotClientApprover,
  TicketModuleAccess,
} from "../../utils/roles";

export default {
  name: "Menu",
  computed: {
    AdminAndCompanyAdmin,
    NotAnalyst,
    NotAccounting,
    OnlyRisk,
    OnlyAdmin,
    OnlyAdminAndAccounting,
    ComplianceAndAdmin,
    NotCompliance,
    AdminCompliance,
    NotClientCompliance,
    OnlyClientCompliance,
    OnlyCompany,
    adminAndRiskAdmin,
    complianceRisk,
    CanApprove,
    OnlyCompanyAdmin,
    NotClientApprover,
    TicketModuleAccess,
    ...mapGetters({
      user: "getUser",
    }),
    getRole: function () {
      return (rol) => getRoleName(rol);
    },
    // Ve el módulo de aprobaciones: quien puede decidir (ADMIN, aprobador del cliente) o el
    // Administrador de Atracción del Talento (COMPANY_ADMIN) de una empresa con el check de aprobación.
    canSeeApprovals: function () {
      if (this.CanApprove(this.user.rol)) return true;
      return (
        this.OnlyCompanyAdmin(this.user.rol) &&
        !!this.user.company &&
        !!this.user.company.hasClientApproval
      );
    },
  },
};
</script>
